import React from 'react';
import { LayoutGridIcon, TrendingUpIcon, ClipboardListIcon, BarChart3Icon, Building2Icon, UsersIcon, RadioIcon, PaletteIcon, UserPlusIcon, MessageSquareIcon, WorkflowIcon, SettingsIcon } from 'lucide-react';
import { useLocation, Link } from 'react-router-dom';
export const Sidebar = () => {
  const location = useLocation();
  const menuItems = [{
    path: '/growth-console',
    label: 'Growth Console',
    icon: TrendingUpIcon
  }, {
    path: '/campaigns',
    label: 'All Campaigns',
    icon: LayoutGridIcon
  }, {
    path: '/creative-customizer',
    label: 'Creative Customizer',
    icon: PaletteIcon
  }, {
    path: '/leads',
    label: 'Leads',
    icon: UserPlusIcon
  }, {
    path: '/conversations',
    label: 'Conversations',
    icon: MessageSquareIcon
  }, {
    path: '/workflows',
    label: 'Workflows',
    icon: WorkflowIcon
  }, {
    path: '/sku-analytics',
    label: 'SKU Analytics',
    icon: BarChart3Icon
  }, {
    path: '/dealer-mis',
    label: 'Dealer MIS',
    icon: Building2Icon
  }, {
    path: '/lead-mis',
    label: 'Lead MIS',
    icon: UsersIcon
  }, {
    path: '/channel-summary',
    label: 'Channel Summary',
    icon: RadioIcon
  }, {
    path: '/settings',
    label: 'Settings',
    icon: SettingsIcon
  }];
  return <div className="w-60 bg-[#0a0a3a] text-white min-h-screen flex flex-col" data-id="element-653">
      <div className="p-6" data-id="element-654">
        <div className="bg-white rounded p-2 w-10 h-10 flex items-center justify-center" data-id="element-655">
          <div className="grid grid-cols-3 gap-1" data-id="element-656">
            {[...Array(9)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-sm bg-blue-600" data-id="element-657"></div>)}
          </div>
        </div>
      </div>

      <nav className="mt-4 flex-1 overflow-y-auto" data-id="element-658">
        {menuItems.map(item => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
        return <Link key={item.path} to={item.path} className={`flex items-center px-6 py-3 transition-colors ${isActive ? 'bg-blue-600' : 'hover:bg-[#1a1a4a]'}`} data-id="element-659">
              <Icon size={18} className="mr-3" data-id="element-660" />
              <span className="text-sm" data-id="element-661">{item.label}</span>
            </Link>;
      })}
      </nav>
    </div>;
};